import useJwt from '@/libs/auth/jwt/useJwt';
const axios = useJwt.axiosIns;

export const getDiagnosisOptions = (params) => axios.get('/api/diagnosis/conservation/options', { params });
export const getFaultAgentsFold = (params) => axios.get('/api/diagnosis/conservation/fold', { params });
export const getFaultAgentsLeftLevel = (params) => axios.get('/api/diagnosis/conservation/left_level', { params });
export const getDiagnosisHandleDetail = (id) => axios.get('/api/diagnosis/conservation/fault/data/' + id);